<template>
    <div>
        <template v-for="(value, index) in getValue">
            <div class="grid-container">
                <dl class="grid-container-attributes">
                    <dt>{{ index }}</dt>
                    <dd>{{ getValueDependsOnType(value) }}</dd>
                </dl>
            </div>
        </template>
    </div>
</template>

<script>

import Vue from "vue";

export default
{
    components: {},
    props: {
        column: {
            type: Object,
        },
        row: {
            type: Object,
        },
    },
    data() {
        return {

        };
    },
    computed: {
        getValue() {
            let value = this.row[this.column.data];

            return JSON.parse(value);
        },
    },
    mounted() {
    },
    methods: {
        getValueDependsOnType(value) {
            if (typeof value == "boolean") {
                return value ? Vue.prototype.$translate.text('Yes') : Vue.prototype.$translate.text('No');
            }

            return value;
        }
    },
}
</script>

<style lang="sass">
</style>


// WEBPACK FOOTER //
// JsonColumnComponent.vue?84e0c320